import { Injectable } from '@angular/core';
import { NewsDocument } from '../models/news-document.interface';
import { NewsImage } from '../models/news-image.interface';
import { NewsLike, NewsLikeType } from '../models/news-like.interface';
import { News } from '../models/news.interface';
import { ApiService } from './api/api.service';

@Injectable()
export class NewsService {
    constructor(private apiService: ApiService) {}

    like(news_id: number, type: NewsLikeType) {
        return this.apiService.postCall$<NewsLike>('news/like', { news_id, type });
    }

    getList(limit?: number, skip?: number, future?: boolean, customerProjectIds?: number[]) {
        future = future || false;
        return this.apiService.getCall$<News[]>(`news/${limit}/${skip}`, {
            future,
            customerProjectIds,
        });
    }

    get(slug: string, copy?: boolean) {
        const params = copy ? { copy } : {};
        return this.apiService.getCall$<News>(`news/${slug}`, params);
    }

    save(news: News) {
        return this.apiService.postCall$<News>('news', news);
    }

    delete(id: number) {
        return this.apiService.deleteCall$(`news/${id}`);
    }

    reserve() {
        return this.apiService.postCall$<News>('news/reserve');
    }

    addImage(id, path) {
        return this.apiService.postCall$<NewsImage>('news/add-image', { id, path });
    }

    sortImages(news: News) {
        return this.apiService.postCall$<NewsImage>('news/sort-images', {
            id: news.id,
            images: news.images.map(p => {
                return {
                    id: p.id,
                    adapt_image: p.adapt_image,
                };
            }),
        });
    }

    rmImage(id) {
        return this.apiService.deleteCall$(`news/rm-image/${id}`);
    }

    addDocument(id, path) {
        return this.apiService.postCall$<NewsDocument>('news/add-document', { id, path });
    }

    sortDocuments(news: News) {
        return this.apiService.postCall$<NewsDocument>('news/sort-documents', {
            id: news.id,
            documents: news.documents.map(p => p.id),
        });
    }

    rmDocument(id) {
        return this.apiService.deleteCall$(`news/rm-document/${id}`);
    }
}
